var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "-11.39 -5 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.613 12L22.28 28.667M45.613 12L42.28 28.667M49.613 12H18.28c-5.6 0-8.4 0-10.54 1.09a10 10 0 00-4.37 4.37C2.28 19.6 2.28 22.4 2.28 28v28c0 5.6 0 8.4 1.09 10.54a10 10 0 004.37 4.37C9.88 72 12.68 72 18.28 72h34.667c5.6 0 8.4 0 10.54-1.09a10.001 10.001 0 004.37-4.37c1.09-2.14 1.09-4.94 1.09-10.54V28.667m-14.849 0H2.28",
    stroke: "currentColor",
    strokeWidth: 4.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.613 2l.737 1.991c.966 2.612 1.45 3.918 2.402 4.87.953.953 2.258 1.436 4.87 2.402l1.991.737-1.992.737c-2.611.966-3.916 1.45-4.869 2.402-.953.952-1.436 2.258-2.402 4.87L69.613 22l-.737-1.991c-.966-2.612-1.45-3.918-2.402-4.87-.953-.953-2.258-1.436-4.87-2.402L59.614 12l1.992-.737c2.611-.966 3.917-1.45 4.869-2.402.953-.952 1.436-2.258 2.402-4.87L69.613 2z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
export default SvgVideo;